export const phoneRegex = new RegExp(/^(0) ?\d{10}$/i)

const UK_PHONE_SEPARATORS = /[\s\-.()]/g
const UK_NATIONAL_PHONE = /^0\d{10}$/
const UK_INTERNATIONAL_PHONE = /^(?:\+|00)?44(\d{10})$/

/**
 * Normalises common ways of writing a UK phone number ("07700 900123",
 * "+44 (0)7700 900123", "0044 7700 900123", "07700-900-123") to
 * 0XXXXXXXXXX. Anything it doesn't recognise is returned unchanged so it
 * still fails phoneRegex validation.
 */
export const normaliseUkPhone = (value: string): string => {
  const compact = value
    .trim()
    .replace(/^(\+|00)?44\s*\(0\)/, "$144")
    .replace(UK_PHONE_SEPARATORS, "")

  if (UK_NATIONAL_PHONE.test(compact)) return compact

  const international = UK_INTERNATIONAL_PHONE.exec(compact)
  if (international) return `0${international[1]}`

  return value
}

export const dateStringSlashesRegex = new RegExp(/\d{2}\/\d{2}\/\d{4}/i)
export const alphabeticRegex = new RegExp(/^[A-Za-z\s]*$/)
export const emailRegex = new RegExp(
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
)

export const MPAN_REGEX = /^\d{13}$/
export const MPRN_REGEX = /^\d{6,10}$/

export const matchRegexExactly = (string: string, regex: RegExp) => {
  const match = regex.exec(string)
  return string === match?.[0]
}
